<template>
  <div id="Statistics">
    <Head />
    <div class="hotspot clear">
      <Nav ms="/Engineering" />
      <div class="H-right">
        <div class="title">平台项目管理</div>
        <div class="H-header">
          <div class="t-right">
            <div class="btn btnmini" @click="Popups('1')">新增</div>
          </div>
          <div class="t-left">
            <input type="text" placeholder="请输入项目名称" />
            <!-- <div class="time">
              <input type="text" v-model="date" placeholder="请选择时间">
              <el-date-picker
                class="time-select"
                v-model="date"
                type="date"
                placeholder="选择开始日期">
              </el-date-picker>
            </div>-->
            <select v-model="status">
              <option value="0">全部状态</option>
              <option value="1">进行中</option>
              <option value="2">已完成</option>
            </select>
            <div class="btn btnmini" style="width: 1rem;">查询</div>
          </div>
        </div>
        <div class="t_main">
          <div class="table">
            <div class="list" v-for="(item,index) in tableData1" :key="index">
              <div class="btn btnmini" @click="Popups(1,item)">修改</div>
              <div class="l-right">
                <img class="l-backtext" :src="item.Image||'../../assets/back/backbg1.png'" alt />
              </div>
              <div class="l-info">
                <div class="l-info-name">
                  <span>{{item.Title}}</span>
                  <i :class="{lanse:item.canup}">{{item.canup?'进行中':'已结束'}}</i>
                </div>
                <div class="l-info-time">
                  <span>申报时间：</span>
                  <div>{{item.StartDate}} 至{{item.EndDate}}</div>
                </div>
                <div class="l-info-text">
                  <span>申报要求:</span>
                  <div>{{SetWord(item.Details)}}</div>
                </div>
              </div>
            </div>
          </div>
          <el-pagination
            style="text-align: right;height: 0.45rem;"
            v-if="tableData1.length>0"
            @current-change="CurrentChange1"
            @size-change="handleSizeChange1"
            :current-page="Page1"
            :page-size="PageSize1"
            :page-sizes="[10, 20, 30]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="total1"
          ></el-pagination>
        </div>
        <div class="Popup" v-show="isPopup">
          <div class="none" @click="Popups(0)"></div>
          <div v-if="isPopup" class="a_forms">
            <div class="f-top">
              <div @click="Popups(0)"></div>
              {{tabType==1?'修改':'新增'}}平台项目
            </div>
            <div class="f-info">
              <div class="p-info">
                <div class="p-input">
                  <span>项目名称：</span>
                  <input type="text" v-model="infoForm.Title" />
                  <i>*</i>
                </div>
                <div class="p-input">
                  <span>开始时间：</span>
                  <div class="p-time">
                    <input type="text" v-model="infoForm.StartDate" />
                    <el-date-picker
                      class="p-select"
                      v-model="infoForm.StartDate"
                      type="datetime"
                      @change="datestrchange"
                      placeholder="选择日期"
                    ></el-date-picker>
                    <div class="icon"></div>
                  </div>
                  <i>*</i>
                </div>
                <div class="p-input">
                  <span>结束时间：</span>
                  <div class="p-time">
                    <input type="text" v-model="infoForm.EndDate" />
                    <el-date-picker
                      class="p-select"
                      v-model="infoForm.EndDate"
                      type="datetime"
                      @change="dateendchange"
                      placeholder="选择日期"
                    ></el-date-picker>
                    <div class="icon"></div>
                  </div>
                  <i>*</i>
                </div>
                <div>
                  <span>申报要求：</span>
                  <div class="quill">
                    <quill-editor
                      ref="myQuillEditor"
                      class="editor"
                      v-model="infoForm.Details"
                      @blur="onEditorBlur($event)"
                      @focus="onEditorFocus($event)"
                      @change="onEditorChange($event)"
                    ></quill-editor>
                  </div>
                  <i>*</i>
                </div>
                <div class="upimg">
                  <span>项目图片：</span>
                  <div class="btn btnmini" style="background: #06A506;" @click="upimg">上传</div>
                  <el-upload
                    ref="uploads"
                    id="upload1"
                    class="avatar-uploader"
                    style="display:none;"
                    :http-request="upload"
                    :auto-upload="false"
                    action="upload1"
                    :on-success="handleSuccess"
                    :on-change="submitUpload"
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                  >
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <span class="imgurl">{{infoForm.Image||'建议尺寸314*156px不大于500kb的图片'}}</span>
                  <i>*</i>
                </div>
              </div>
              <div class="f-bottom">
                <div
                  class="btn"
                  style="border-radius: 0.08rem;"
                  v-if="tabType==0"
                  @click="addinfo"
                >提交</div>
                <div class="btn" style="border-radius: 0.08rem;" v-else @click="setInfo">提交</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
export default {
  name: "Expert",
  data() {
    return {
      total1: 1,
      datestr: "",
      dateend: "",
      date: "",
      status: "0",
      tableData1: [],
      Page1: 1,
      value: 1,
      PageSize1: 10,
      tabType: "",
      isPopup: false,
      infoForm: {
        Title: "",
        Details: "",
        Date: "1970-01-01",
        Type: "7",
        Status: 0,
        FileCode: "",
        StartDate: "",
        EndDate: "",
        Image: ""
      },
      redianForm: {
        Title: "",
        Details: "",
        Date: "1970-01-01",
        Type: "7",
        Status: 0,
        FileCode: "",
        StartDate: "",
        EndDate: "",
        Image: ""
      } //热点缓存
    };
  },
  created() {
    this.getinfo();
  },
  methods: {
    upimg() {
      document.querySelector(".avatar-uploader input").click();
    },
    Popups(e, f) {
      if (e == 1) {
        if (f) {
          this.infoForm = Object.assign({}, f);
          this.tabType = 1;
        } else {
          this.tabType = 0;
          this.infoForm = Object.assign({}, this.redianForm);
        }
        this.isPopup = !this.isPopup;
      } else {
        this.redianForm = Object.assign({}, this.infoForm);
        this.isPopup = !this.isPopup;
      }
    },
    datestrchange(e) {
      console.log(e);
      this.infoForm.StartDate = this.getSelectTime(e);
    },
    dateendchange(e) {
      console.log(e);
      this.infoForm.EndDate = this.getSelectTime(e);
    },
    CurrentChange1(val) {
      //console.log(val)
      this.Page1 = val;
      this.getinfo();
    },
    handleSizeChange1(val) {
      //console.log(val)
      this.PageSize1 = val;
      this.getinfo();
    },
    Del(e) {
      var that = this;
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.$axios
            .post(
              "information/del?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify({ ID: e.ID })
            )
            .then(res => {
              console.log(res);
              if (res.data.code == 10000) {
                that.$message({
                  message: "删除成功",
                  type: "success"
                });
                that.getinfo();
              } else {
                that.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    onEditorBlur(e) {
      console.log(e);
    },
    onEditorFocus(e) {
      //获得焦点事件
      console.log(e);
    },
    onEditorChange(e) {
      //内容改变事件
      console.log(e);
    },
    setInfo() {
      var that = this;
      this.$confirm("确认修改吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.$axios
            .post(
              "information/update?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify(this.infoForm)
            )
            .then(res => {
              console.log(res);
              if (res.data.code == 10000) {
                that.$message({
                  message: res.data.msg,
                  type: "success"
                });
                that.getinfo();
                this.Popups(0);
              } else {
                that.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消修改"
          });
        });
    },
    addinfo() {
      var that = this;
      that.$axios
        .post(
          "information/add?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify(this.infoForm)
        )
        .then(res => {
          if (res.data.code == 10000) {
            console.log(res.data.data);
            that.$message({
              message: res.data.msg,
              type: "success"
            });
            that.getinfo();
            this.Popups(0);
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning"
            });
          }
        });
    },
    SetWord(v) {
      if (v != null) {
        var dd = v.replace(/<\/?.+?>/g, "");
        var dds = dd.replace(/ /g, ""); //dds为得到后的内容
        if (dds.length > 100) {
          dds = dds.substr(0, 100);
          dds += "...";
        }
        return dds;
      }
    },
    getinfo(a) {
      if (a == 1) {
        this.Page1 = 1;
      }
      var that = this;
      that.$axios
        .post(
          "information/index?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            Title: "",
            Type: 7,
            page: this.Page1,
            num: this.PageSize1
          })
        )
        .then(res => {
          if (res.data.code == 10000) {
            console.log(res.data.data);
            res.data.data.list.forEach(el => {
              el.canup = new Date() > new Date(el.EndDate) ? "false" : "true";
            });
            this.tableData1 = res.data.data.list;
            this.total1 = res.data.data.total_num;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning"
            });
          }
        });
    },
    submitUpload() {
      this.$refs.uploads.submit();
    },
    // 测试上传
    handleSuccess(response, file, fileList) {
      console.log(response);
      console.log(file, fileList);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || "image/gif" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是图片格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    upload(file) {
      let that = this;
      console.log(file);
      var formData = new FormData();
      formData.append("file", file.file);
      formData.append("upload_type", "image");
      that.$axios
        .post(
          "upload/index?token=" + sessionStorage.getItem("token"),
          formData,
          {
            headers: {
              "Content-type": "multipart/form-data"
            }
          }
        )
        .then(res => {
          console.log(res);
          if (res.data.code == 10000) {
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.infoForm.Image = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      this.$refs.uploads.clearFiles();
    }
  },
  components: {
    Head,
    Foot,
    Nav
  }
};
</script>
<style lang="less" scoped>
.time {
  position: relative;
  .time-select {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
}
.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.btn {
  width: 4.6rem;
  cursor: pointer;
  height: 0.58rem;
  line-height: 0.58rem;
  font-size: 0.17rem;
  text-align: center;
  background: #2d65d2;
  color: #fff;
}
.btnchange {
  background-color: #f2f2f4;
  color: #000000;
}
.btnmini {
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-radius: 0.05rem;
}
.hotspot {
  width: 100%;
  min-width: 1000px;
  font-size: 0.16rem;
  padding: 0.28rem 2.54rem;
  box-sizing: border-box;
  .H-right {
    position: relative;
    width: 11.5rem;
    min-width: 750px;
    padding-left: 0.2rem;
    height: 100%;
    float: right;
    min-height: 7.4rem;
    border-left: 1px #eeeeee solid;
    .title {
      font-size: 0.4rem;
      margin: 0.2rem 0 0.5rem;
      text-align: center;
    }
    .btnselect {
      display: flex;
    }
    .H-header {
      .t-left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 0.5rem;
        > span,
        select,
        div,
        input {
          margin-right: 0.2rem;
          width: 2rem;
          height: 0.4rem;
        }

        input {
          padding: 0.05rem;
        }
      }
      .t-right {
        float: right;
      }
    }
    .t_main {
      .table {
        .list {
          width: 100%;
          height: 2rem;
          display: flex;
          align-items: center;
          position: relative;
          border-bottom: 1px #d9d9d9 solid;
          &:hover {
            background: #f0f0f0;
          }
          .btn {
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
          }
          .l-right {
            width: 3.14rem;
            height: 1.56rem;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .l-info {
            flex: 1;
            padding-left: 0.3rem;
            font-size: 0.16rem;
            color: #4e4e4e;
            height: 100%;
            .l-info-name {
              .lanse {
                width: .7rem;
                height: 0.3rem;
                line-height: 0.3rem;
                background: #2d65d2;
              }
              span {
                font-size: 0.2rem;
                font-weight: bold;
                color: #171717;
                line-height: 0.6rem;
              }
              i {
                font-style: normal;
                background: #ff0a0a;
                color: #ffffff;
                display: inline-block;
                font-size: 0.14rem;
                margin-left: 0.2rem;
                height: 0.19rem;
                text-align: center;
                border-radius: 0.04rem;
              }
            }
            .l-info-text {
              height: 0.77rem;
            }
            .l-info-text,
            .l-info-time {
              span {
                float: left;
                line-height: 0.25rem;
              }
              div {
                margin-left: 1rem;
                line-height: 0.25rem;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
              }
            }
          }
        }
      }
    }
  }
}
.Popup {
  width: 100%;
  position: absolute;
  top: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;

  .none {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .a_forms {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 7rem;
    height: 7rem;
    background: white;
    font-size: 0.16rem;
    .f-top {
      height: 0.5rem;
      width: 100%;
      text-align: center;
      line-height: 0.5rem;
      position: relative;
      border-bottom: 1px #cfcfcf solid;
      div {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: 0;
        height: 0.5rem;
        width: 0.5rem;
        background: url("../../assets/back/x.png") center center no-repeat;
      }
    }
    .f-info {
      padding: 0.2rem 0.68rem 0;
      .p-info {
        > .p-input {
          align-items: center;
        }
        > .upimg {
          align-items: center;
          justify-content: space-between;
          > .imgurl {
            display: block;
            width: 3rem;
            word-wrap: break-word;
          }
        }
        > div {
          margin: 0.2rem 0;
          display: flex;
          > .p-time {
            position: relative;
            flex: 1;
            margin: 0 0.2rem;
            > input {
              width: 100%;
              padding: 0.05rem;
              height: 0.3rem;
              border: 1px #cccccc solid;
            }
            .p-select {
              width: 100%;
              top: 0;
              left: 0;
              opacity: 0;
              position: absolute;
            }
            .icon {
              position: absolute;
              top: 0;
              right: 0;
              height: 0.3rem;
              width: 0.3rem;
              background: url("../../assets/back/time.png") center center
                no-repeat;
            }
          }
          > input {
            flex: 1;
            padding: 0.05rem;
            margin: 0 0.2rem;
            height: 0.3rem;
            border: 1px #cccccc solid;
          }
          > .quill {
            flex: 1;
            height: 3rem;
            overflow: auto;
          }
          > textarea {
            flex: 1;
            padding: 0.05rem;
            margin: 0 0.2rem;
            border: 1px #cccccc solid;
          }
          i {
            font-style: normal;
            color: #ff0d0d;
          }
        }
      }
      .f-bottom {
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
    }
  }
}
</style>